import {
  isValidEmail,
  isValidPhone,
  updatePhoneValueSearch,
} from '@sales-center/common'
import {
  IFilterSet,
  IOrderBy,
  IMultiSelectFilter,
  normalizeFilters,
} from '@user/components/Filters'
import { ILocation } from './typings'

export interface LocationFilterSet extends IFilterSet<ILocation> {
  filters: {
    postalCode: IMultiSelectFilter<ILocation>
  }
}

export const orderByOptions: IOrderBy[] = [
  { label: 'Contact Name (A-Z)', value: 'fullName asc' },
  { label: 'Contact Name (Z-A)', value: 'fullName desc' },
]

export const defaultFilters: LocationFilterSet = normalizeFilters<
  ILocation,
  LocationFilterSet
>({
  appliedCount: 0,
  normalizedFilters: [],
  orderBy: 'fullName asc',
  filters: {
    postalCode: {
      propertyName: 'postalCode',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: true,
      value: { mode: 'any', options: [] },
    },
  },
  search: {
    value: '',
    placeholder: 'Name, email, phone, address',
    searchFields: [
      {
        propertyNames: ['fullName'],
        matchType: 'contains',
        include: /^[^\d]{1,100}$/,
      },
      {
        propertyNames: ['emailAddress'],
        matchType: 'eq',
        include: isValidEmail,
      },
      {
        propertyNames: ['phoneNumber'],
        matchType: 'eq',
        include: isValidPhone,
        formatter: updatePhoneValueSearch,
      },
      {
        propertyNames: ['street1'],
        matchType: 'contains',
      },
    ],
  },
})
